var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"health-reviewed-line"},[(_vm.loaded)?[(_vm.reviewedDt)?[_vm._v(" ทบทวนล่าสุด "+_vm._s(_vm.text)),(_vm.showDaysAgo)?[_vm._v(" ("+_vm._s(_vm.daysAgo)+" วันก่อน)")]:_vm._e()]:[_vm._v("ยังไม่เคยทบทวน")]]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }